<template>
  <section
    v-if="messages"
    class="certiface-verify"
  >
    <div
      v-for="(message, index) in messages"
      v-if="message.type == 'msg'"
      :key="index"
      class="input-wrapper"
      v-html="message.text"
    />

    <div
      v-for="(message, index) in messages"
      v-if="message.type == 'link'"
      :key="index"
      class="input-wrapper"
    >
      <a
        class="donation-nav donation-nav--rewind"
        :href="'/'+ candidate.username +'#doar'"
      >voltar</a>
      <a
        target="_blank"
        class="donation-nav donation-nav--block"
        :href="message.href"
      >{{ message.text }} </a>
    </div>
  </section>
</template>

<script>

	export default {
		name: 'PrintBoleto',
		data() {
			return {
				loading: false,
        dataBusyMessage: '',
				errorMessage: '',

				validation: {
					errors: {},
				},
			};
		},
		computed: {
			username() {
				return this.$store.state.username;
			},
			messages() {
				return this.$store.state.messages.messages;
			},
			candidate() {
				return this.getMergeCandidate.candidate;
			},
			getMergeCandidate() {
				return this.$store.getters.generateCandidateObject;
			},
		},
		mounted() {
			this.scrollToDonate();
		},
		methods: {
			scrollToDonate() {
				const form = document.getElementById('doar');
				form.scrollIntoView({ block: 'start', behavior: 'smooth' });
			},
      toggleLoading(message = '') {
        this.loading = !this.loading;

        this.dataBusyMessage = this.dataBusyMessage !== message
          ? message
          : '';
      },
			handleErrorMessage(err) {
				this.errorMessage = err.data[0].message;
			},
			redirectUser(ui) {
				if( ui.value === "pay_with_cc" ){
					this.$router.replace(this.$route.path);
						this.$store.dispatch("CHANGE_PAYMENT_STEP", {
							step: "userData"
					});
				}else{
					sessionStorage.clear();
					window.open(ui.href)
				}
			}
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascript/components/steps/printBoleto.vue